import React, { useMemo, useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import kebabCase from 'lodash/kebabCase';
import { DNABox, DNAIcon, DNAText, Iffy, util } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  pressable: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    color: colors['color-text-primary'],
    fontWeight: 'bold',
  },
  headerTextHovered: {
    color: colors['color-gray-800'],
  },
  icon: {
    marginLeft: 8,
  },
})

interface SortableHeaderTextProps {
  lable: string;
  isActive?: boolean;
  isSortedAsc?: boolean;
  onPress: () => void;
}

const SortableGridListHeaderText: React.FC<SortableHeaderTextProps> = React.memo(({
  lable,
  isActive,
  isSortedAsc,
  onPress,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const style = useMemo(() => util.mergeStyles(
    undefined,
    styles.headerText,
    [styles.headerTextHovered, isHovered || isActive],
  ), [isHovered, isActive]);

  return (
    <DNABox appearance="row" spacing="sm">
      <Pressable
        testID={`header-sort-${kebabCase(lable)}`}
        onPress={onPress}
        onHoverIn={() => setIsHovered(true)}
        onHoverOut={() => setIsHovered(false)}
        style={styles.pressable}
      >
        <DNAText style={style}>{lable}</DNAText>
        <Iffy is={isActive}>
          <DNAIcon.Styled
            name={isSortedAsc ? 'caret-up-fill' : 'caret-down-fill'}
            width={12}
            height={12}
            style={[style, styles.icon]}
          />
        </Iffy>
      </Pressable>
    </DNABox>
  )
})

export default SortableGridListHeaderText;
